import axios from "axios";

axios.defaults.headers.common["Content-Type"] = "application/json";
axios.defaults.headers.common["scd"] = "APLYNXSCD";

//axios.defaults.baseURL = consts.apiBaseUrl;


export const postData = (url, sender={}) => {
    axios.defaults.headers.common["authorization"] = localStorage.getItem('token');

    let dm = "https://api.maemul.net"; // PNSOFT TEST SERVER
    // let dm = "https://api.esrks-db.com"; // ESR LIVE SERVER
    //console.log(sender);
    return axios.post(dm + `${url}`, sender );
};

export const mobileokpostData = (url, sender={}) => {
    //axios.defaults.headers.common["authorization"] = localStorage.getItem('token');
    // let dm = "https://api.esrks-db.com"; // ESR LIVE SERVER
    console.log(sender);
    return axios.post(url, sender );
};